import React, { PureComponent } from 'react'
import { getAttributeRequired, getComponentDefinition, getComponentLabel, getTrackingFactLabel } from '../../helper'
import AttributeInput from '../attribute-input'
import PropTypes from 'prop-types'
import { SHAPE_COMPONENT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import { withTranslation } from 'react-i18next'
import './styles.scss'
import SelectTracked from '../../../FormTracked/SelectTracked'
import { trackingEvent } from '../../../../../constants'
import FactsheetComponentLabel from '../factsheet-component-label'

class AttributeInputWithUnit extends PureComponent {

  state = {
    value: '',
    unitDefId: ''
  }

  componentDidMount () {
    this.updateState()
  }

  componentDidUpdate () {
    this.updateState()
  }

  updateState () {
    // Derive next state from props and validate against available units to avoid stale state reuse
    const attributeDefId = this.props.blueprint.id
    const attribute = this.props.factsheetBlueprint.factTree.attributes[attributeDefId]
    const units = attribute.value?.units ?? []

    let nextValue = ''
    let nextUnitDefId = this.state.unitDefId

    if (typeof this.props.data !== 'undefined') {
      nextValue = this.props.data.value
      nextUnitDefId = this.props.data.unitDefId || ''
    }

    // If current unit is not available for this attribute (or empty), fall back to first available
    const unitIsValid = nextUnitDefId !== '' && units.includes(nextUnitDefId)
    if (!unitIsValid) {
      nextUnitDefId = units[0] || ''
    }

    if (nextValue !== this.state.value || nextUnitDefId !== this.state.unitDefId) {
      this.setState({
        value: nextValue,
        unitDefId: nextUnitDefId
      })
    }
  }

  onValueChange = (factDefId, factInstanceKey, attributeDefId, payload) => {
    payload.unitDefId = this.state.unitDefId
    this.props.putAttribute(factDefId, factInstanceKey, attributeDefId, payload)
  }

  onUnitChange = (e) => {
    if (e.target.value !== '') {
      let unitDefId = e.target.value
      this.setState({ unitDefId })
      if (this.state.value !== '') {
        const payload = {
          attributeDefId: this.props.blueprint.id,
          value: this.state.value,
          unitDefId: unitDefId
        }
        // re-emits the existing value under a new unit, not a fresh user set -> skip the check.
        this.props.putAttribute(this.props.parentBlueprint.id, this.props.factInstanceKey, this.props.blueprint.id, payload, { skipContradictionCheck: true })
      }
    }
  }

  render () {
    const attributeDefId = this.props.blueprint.id
    const attribute = this.props.factsheetBlueprint.factTree.attributes[attributeDefId]
    const label = getComponentLabel(this.props.blueprint, attribute)

    if (this.props.collapsed) {
      if (this.state.value === '') {
        return null
      }
      const unit = this.state.unitDefId ? this.props.factsheetBlueprint.factTree.units[this.state.unitDefId].label : ''
      return <div className={'attribute-input-with-unit-collapsed'}>{label}: {this.state.value}{unit}</div>
    }

    const factDefId = this.props.parentBlueprint.id
    const fact = this.props.factsheetBlueprint.factTree.facts[factDefId]
    const required = getAttributeRequired(this.props.blueprint, attribute, fact)
    const definition = getComponentDefinition(
      this.props.blueprint,
      attribute
    )
    const units = attribute.value?.units ?? []
    const options = []
    for (const unit of units) {
      const option = {
        value: unit,
        label: this.props.factsheetBlueprint.factTree.units[unit].label
      }
      options.push(option)
    }

    return (
      <div className={'attribute-input-with-unit'}>
        <div className={'attribute-input-with-unit-header'}>
          <FactsheetComponentLabel label={label} required={required.attribute} definition={definition}/>
        </div>
        <div>
          <div className={'attribute-input-with-unit-select-box'}>
            <SelectTracked
              eventName={trackingEvent.editValue}
              eventOpts={
                {
                  name: getTrackingFactLabel(
                    this.props.parentBlueprint, this.props.factsheetBlueprint)
                }
              }
              options={options}
              selected={this.state.unitDefId !== '' ? this.state.unitDefId : units[0]}
              onChange={this.onUnitChange}/>
          </div>
          <div className={'attribute-input-with-unit-input-box'}>
            <AttributeInput blueprint={this.props.blueprint}
                            parentBlueprint={this.props.parentBlueprint}
                            factsheetBlueprint={this.props.factsheetBlueprint}
                            factInstanceKey={this.props.factInstanceKey}
                            data={this.props.data}
                            collapsed={this.props.collapsed}
                            putAttribute={this.onValueChange}
                            deleteAttribute={this.props.deleteAttribute}
                            putValidationStatus={this.props.putValidationStatus}
                            showLabel={false}/>
          </div>
        </div>
      </div>
    )
  }
}

AttributeInputWithUnit.propTypes = {
  blueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  parentBlueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  factInstanceKey: PropTypes.number.isRequired,
  data: PropTypes.object,
  collapsed: PropTypes.bool.isRequired,
  putAttribute: PropTypes.func.isRequired,
  deleteAttribute: PropTypes.func.isRequired,
  putValidationStatus: PropTypes.func.isRequired
}
export default withTranslation()(AttributeInputWithUnit)
